/**
 * @file This file contains very simple short utils to help.
 *
 * WARNING: This file was @generated by "ts/internal/autotest-step-generator/src/writers/utils.ts", do not edit.
 */
/** All wrapper steps. */
export const allWrapperTypes = new Set([
    'test-hide',
    'run-in',
    'run-if',
    'allow-internet',
    'connect-rubric',
    'weight',
    'test-timeout-each',
    'jupyter-notebook',
    'snapshot',
    'io-test',
    'code-structure-test',
    'quiz',
    'coding-question',
    'prompt-engineering-question',
]);
/** All non-wrapper steps. */
export const allNonWrapperTypes = new Set([
    'checkstyle',
    'java-compile',
    'junit5',
    'custom-test',
    'flake8',
    'pytest',
    'simple-python-test',
    'run-in-notebook',
    'output',
    'test-upload-files',
    'simple-match',
    'regex-match',
    'substring-match',
    'negative-match',
    'positive-match',
    'mcq',
    'select-all-question',
    'program',
    'install-dotnet',
    'install-java',
    'install-python',
    'install-node',
    'upload-files',
    'install-clang',
    'install-gcc',
    'script',
    'auto-install-flake8',
    'auto-install-pytest',
    'auto-install-code-structure-test',
    'auto-install-simple-python-test',
    'auto-install-jupyter-notebook',
]);
/** All steps with a name. */
export const allWithNameTypes = new Set([
    'checkstyle',
    'java-compile',
    'junit5',
    'custom-test',
    'flake8',
    'pytest',
    'simple-python-test',
    'jupyter-notebook',
    'run-in-notebook',
    'output',
    'test-upload-files',
    'io-test',
    'simple-match',
    'regex-match',
    'substring-match',
    'code-structure-test',
    'negative-match',
    'positive-match',
    'coding-question',
    'prompt-engineering-question',
    'mcq',
    'select-all-question',
    'program',
    'upload-files',
    'script',
]);
/** All quiz question steps. */
export const allQuizTypes = new Set([
    'coding-question',
    'prompt-engineering-question',
    'mcq',
    'select-all-question',
]);
/** All test steps. */
export const ALL_TEST_STEP_TYPES = Object.freeze([
    'test-hide',
    'run-in',
    'run-if',
    'allow-internet',
    'connect-rubric',
    'weight',
    'checkstyle',
    'java-compile',
    'junit5',
    'custom-test',
    'test-timeout-each',
    'flake8',
    'pytest',
    'simple-python-test',
    'jupyter-notebook',
    'run-in-notebook',
    'output',
    'test-upload-files',
    'snapshot',
    'io-test',
    'simple-match',
    'regex-match',
    'substring-match',
    'code-structure-test',
    'negative-match',
    'positive-match',
    'quiz',
    'coding-question',
    'prompt-engineering-question',
    'mcq',
    'select-all-question',
    'program',
]);
/** All build/setup steps. */
export const ALL_BUILD_STEP_TYPES = Object.freeze([
    'install-dotnet',
    'install-java',
    'install-python',
    'install-node',
    'upload-files',
    'install-clang',
    'install-gcc',
    'script',
]);
/** All build/setup steps that can be created by users. */
export const ALL_AUTO_INSTALL_STEP_TYPES = Object.freeze([
    'auto-install-flake8',
    'auto-install-pytest',
    'auto-install-code-structure-test',
    'auto-install-simple-python-test',
    'auto-install-jupyter-notebook',
]);
/** A mapping between step type and the display name. */
export const ALL_STEP_NAMES = Object.freeze({
    'test-hide': 'Hide',
    'run-in': 'Run Only In',
    'run-if': 'Run If',
    'allow-internet': 'Allow Internet',
    'connect-rubric': 'Connect Rubric',
    weight: 'Weight',
    checkstyle: 'Checkstyle',
    'java-compile': 'Java Compile',
    junit5: 'Junit5',
    'custom-test': 'Custom Test',
    'test-timeout-each': 'Timeout Each',
    flake8: 'Flake8',
    pytest: 'Pytest',
    'simple-python-test': 'Simple Python Test',
    'jupyter-notebook': 'Jupyter Notebook',
    'run-in-notebook': 'Run In Notebook',
    output: 'Output',
    'test-upload-files': 'Upload Files',
    snapshot: 'Isolate',
    'io-test': 'IO Test',
    'simple-match': 'Full Match',
    'regex-match': 'Regex Match',
    'substring-match': 'Substring Match',
    'code-structure-test': 'Code Structure Test',
    'negative-match': 'Negative Match',
    'positive-match': 'Positive Match',
    quiz: 'Quiz',
    'coding-question': 'Coding Question',
    'prompt-engineering-question': 'Prompt Engineering Question',
    mcq: 'Multiple Choice Question',
    'select-all-question': 'Select All Question',
    program: 'Script',
    'install-dotnet': 'Install .NET',
    'install-java': 'Install Java',
    'install-python': 'Install Python',
    'install-node': 'Install Node',
    'upload-files': 'Upload Files',
    'install-clang': 'Install Clang',
    'install-gcc': 'Install GCC',
    script: 'Script',
    'auto-install-flake8': 'Auto Install Flake8',
    'auto-install-pytest': 'Auto Install Pytest',
    'auto-install-code-structure-test': 'Auto Install Code Structure Test',
    'auto-install-simple-python-test': 'Auto Install Simple Python Test',
    'auto-install-jupyter-notebook': 'Auto Install Jupyter Notebook',
});
